<template>
  <div class="header">
    <div class="header_left">
      <img src="@images/newlogo1.png" alt="" class="logo" />
      <!-- <div class='span'>仟抖助手</div> -->
      <!-- <span style="margin-top: 24px;font-size:16px;color: #000c41;">  抖音官方投流智能投放助手</span> -->
    </div>
    <div class="header_right">


      <div class="userWapper">

      <!-- <b class="kefu" style="color: #633bfe;" @click="hdVisible = true"> <a-icon type="fire" /> 双11 大促</b> -->
        <!-- <b class="kefu" style="color:red;" @click="kefu"> <a-icon type="fire" /> 千川涨粉咨询 </b> -->
        <span class="kefu" >
        <a href="https://fuwu.oceanengine.com/product/7184717543884472353" target="_blank" style="color:red"><a-icon type="gift" /> 会员充值续费入口</a>
      </span>

        <span class="kefu" >
        <a href="https://k2xwm4crei.feishu.cn/docx/HqKQddri7o6ijYxhZiqccYRonBe" target="_blank"><a-icon type="file-add" /> 使用教程</a>
      </span>

      <span class="kefu" style="color:#16b010">

        <a-popover placement="topLeft">
                <template slot="content">
                  <p><img src="@images/xcx.jpg" style="width:150px"> </p>
                </template>
                <span slot="title"><b style="text-align: center;display: block;">微信扫一扫识别</b></span> 
                <a-icon type="message" theme="twoTone" two-tone-color="#16b010" /> 小程序  
              </a-popover>


      </span>

        <span class="kefu" @click="kefu">
          <a-icon type="message" />
          在线客服
        </span>

        <span class="kefu" @click="closevisible = true">
          <a-icon type="edit" />
          需求反馈
        </span>


        <span class="kefu">
          <a-icon type="bell" theme="filled" />
        </span>


        <img class="userAvatar" :src="wxInfo.avatar" v-if="wxInfo && wxInfo.avatar" />
        <a-avatar style="backgroundcolor: #87d068" icon="user" v-else />
        <span class="userName">{{ userName }} (ID:{{userId}})</span>
        <icon-font type="ic-logout" class="logoutIcon" title="退出" @click="logOut"></icon-font>
      </div>
    </div>

    <a-modal v-if="closevisible" v-model="closevisible" title="需求/反馈" width="800px" okText="提交反馈" @ok="feedback"
      :zIndex="1001">
      <div class="authTypeWapper" style="color:#666666">
        <h4>亲爱的仟抖助手用户您好：感谢您的反馈，您的问题我们将会第一时间阅读、分析后给您尽快回复，祝您持续爆单！</h4>
        <a-form>
        <a-form-item label="反馈平台">
          <a-radio-group default-value="QC" @change="handleFormChange">
            <a-radio-button value="QC">
              巨量千川
            </a-radio-button>
            <a-radio-button value="SXT">
              小店随心推
            </a-radio-button> 
          </a-radio-group>
        </a-form-item>
        <a-form-item label="反馈内容">
          
          <a-textarea
            v-model="content"
            placeholder="请输入您需要反馈的内容"
            :auto-size="{ minRows: 3, maxRows: 5 }"
          />


        </a-form-item>

        </a-form>

      </div>
    </a-modal>


    <!-- <a-modal v-if="hdVisible" :visible="hdVisible" :footer="null" width="600px" @cancel="hdVisible=false" >
      <div class="dqtitle">20240617-更新日志</div> 
      <div class="dqtag"> 
        <p>1:巨量千川板块更新评论管理板块，支持批量回复评论，批量删除评论，批量操作屏蔽词等。 </p>
        <p>2:随心推板块更新评论管理板块，支持批量回复评论，批量删除评论，批量操作屏蔽词等。 </p>
      </div>
    </a-modal> -->
	  <a-modal v-if="hdVisible" :visible="hdVisible" :footer="null" width="500px" @cancel="hdVisible=false" >
      <div class="dqtitle">双11 大促 - 充值享好礼</div> 
      <div class="dqtag"> 
        <p>1:活动时间：：2024-11-01 至 2024-11-11  </p>
         <p>2:活动期间续费随心推年卡用户可享受 赠送巨量千川会员半年卡 。</p>
        <p>3.充值续费客户均可享受1对1客服服务。</p>
        <p>4.活动期间续费客户可享受返积分服务，积分可用来下载高清原创素材。</p>
      </div>
      <div class="dqbtn">
        <a-button style="background: #fe346e;color: #fff;border: none;" size="large" @click="kefu">联系客服</a-button>
        <a-button  size="large" @click="hdVisible=false">我知道了</a-button>
      </div>
    </a-modal>

  </div>




</template>
<script>
import { qcApi, requestHttp } from '@utils/index';
import { mapState } from 'vuex';
import { Modal } from 'ant-design-vue';
import kfsrc from '../../assets/images/kefu2.jpg'
import xcx from '../../assets/images/xcx.jpg'

export default {
  name: 'Header',
  props: {},

  data() {
    return {
      closevisible: false,
      type:"QC",
      content:'',
      hdVisible:false,
      updateVisible:false
    };
  },

  components: {},

  computed: {
    ...mapState('User', ['wxInfo']),
    userName() {
      return this?.wxInfo?.nickname || '';
    },
    userId() {
      return this?.wxInfo?.id || '';
    },
  },
  watch: {},


  mounted() {
    console.log('wxInfo', this.wxInfo);
  },
  methods: {
    async feedback() {
      if(this.type == ''){
        this.$message.error('请选择您要反馈的平台')
        return
      }
      if(this.content == ''){
        this.$message.error('请输入您反馈的内容')
        return
      }
      const { code, msg, data } = await requestHttp({
        api: `${qcApi.ADD_USER_FEEDBACK}`,
        method: 'POST',
        params: {
          type: this.type, 
          content: this.content,
        },
      });
      if (code == 0) {
        this.$message.error(msg);
        return;
      }
      this.closevisible = false
      this.content=''
      this.$message.success(msg) 
    },
    handleFormChange(e){
      this.type = e.target.value;
    },
    kefu() {
      console.log('1111', this.kfsrc)
      const h = this.$createElement;
      this.$info({
        title: '添加客服微信：ffdada99',
        content: h('div', {}, [
          h('img', { attrs: { src: kfsrc }, style: { width: '270px' } }),
        ]),
        onOk() { },
      });
    },
    logOut() {
      Modal.confirm({
        title: '提醒',
        content: '确定是否退出登录？',
        onOk: () => {
          this.$store.commit('User/CLEAR_TOKEN');
          this.$router.replace('login');
        },
      });
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  background: #fff;
  box-shadow: 0 2px 8px #00000026;
  height: 64px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  .header_left {
    height: 100%;
    box-sizing: border-box;
    padding-left: 10px;
    display: flex;

    .span {
      font-size: 22px;
      padding-top: 15px;
      display: block;
      font-weight: bold;
      color: #1e47c8;
      letter-spacing: 5px;
    }
  }

  .header_right {
    height: 100%;
    box-sizing: border-box;
    padding: 10px;
  }

  .logo {
    height: 55px;
    margin-top: 7px;
    margin-left: 10px;
    margin-right: 10px;
    width: auto;
  }

  .userWapper {
    display: flex;
    align-items: center;
    margin-right: 10px;
    margin-top: 5px;
    color: #666;
  }

  .kefu {
    color: #666;
    cursor: pointer;
    font-size: 16px;
    text-align: center;
    padding-right: 20px;
    // font-weight: bold;
    margin-top: 5px;
  }

  .kefu:hover {
    color: #333;
  }

  .userAvatar {
    width: 32px;
    height: 32px;
    border-radius: 50%;
  }

  .userName {
    font-size: 16px;
    font-weight: bold;
    margin: 0 15px;
  }

  .logoutIcon {
    font-size: 20px;
    margin-left: 5px;
    color: #0d55fd;
    cursor: pointer;
  }
}
.dqtitle{
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #fe346e;
  margin-bottom: 20px
}
.dqtag{
  font-size: 14px;
  color: #333;
  text-align: left;
  font-weight: bold;
}
.dqbtn{
  margin-top: 20px;
  button{
    margin-bottom: 10px;
    width:100%
  }
}
</style>
